import { State } from '../../reducers/rootReducer'
import { AiRecommendationsForModelDataState } from '../../reducers/aiRecommendationsForModelDataReducer'

const aiRecommendationsForModelDataSelector = (state: State): AiRecommendationsForModelDataState => state.aiRecommendationsForModel

export default aiRecommendationsForModelDataSelector
